import { cn } from '@tripleten/cn';

export const cnPasswordStrength = cn('password-strength');
